import { darkModetoggler, ready } from "./utils";
import 'flowbite';
import { createApp } from 'vue';
import App from './App.vue';

// const checkRestApi = () => {
//   console.log('check rest api')
//   var data = JSON.stringify({
//     "title": "New Title with credentials"
//   });
  
//   var xhr = new XMLHttpRequest();
//   xhr.withCredentials = true;
  
//   xhr.addEventListener("readystatechange", function() {
//     if(this.readyState === 4) {
//       console.log(this.responseText);
//     }
//   });
  
//   xhr.open("PUT", "https://projects.local/wp-json/wp/v2/projects/20?_wpnonce=" + ajax_url.nonce);
//   xhr.setRequestHeader("Content-Type", "application/json");
//   xhr.setRequestHeader("Authorization", "Basic cm9vdDo5YTNLIERsQWUgV0NqSCBVOE9wIHluVzYgakJ1UQ==");
  
//   xhr.send(data);
// }

createApp(App).mount('#vue-app');

darkModetoggler();

// ready(() => {
//   checkRestApi();
// })
